import React, { useContext, useEffect } from 'react';

import InformacoesPessoaisForm1 from './forms/InformacoesPessoaisForm1';
import { Route, useLocation } from 'react-router-dom';

import { ProfileContext } from 'pages/profile/context/ProfileContext';

export interface IInformacoesPessoais {}

const InformacoesPessoais = ({}: IInformacoesPessoais) => {
    const { _setPostProfilePath } = useContext(ProfileContext.Context);
    const location: any = useLocation();

    useEffect(() => {
        if (location && location?.state.postProfilePath) {
            _setPostProfilePath(location?.state.postProfilePath);
        }
    }, []);

    return (
        <>
            <Route path={'/profile/informacoes'} exact component={InformacoesPessoaisForm1} />
        </>
    );
};

export default InformacoesPessoais;
